import {
  Label,
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import { IconSelector, IconCheck } from "@tabler/icons-react";

function ImageSelectMenu({ items, selected, setSelected }) {
  return (
    <Listbox value={selected} onChange={setSelected}>
      <Label className="block text-sm/6 font-medium text-gray-900 dark:text-white">
        Assigned to
      </Label>
      <div className="relative mt-2">
        <ListboxButton className="grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pr-2 pl-3 text-left text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-indigo-600 sm:text-sm/6 dark:bg-gray-800/50 dark:text-white dark:outline-white/10 dark:focus-visible:outline-indigo-500">
          <ButtonLabel
            selected={items.filter((x) => x.userId === selected)[0]}
          />
          <IconSelector
            aria-hidden="true"
            className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4 dark:text-gray-400"
          />
        </ListboxButton>

        <ListboxOptions
          transition
          className="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg outline-1 outline-black/5 data-leave:transition data-leave:duration-100 data-leave:ease-in data-closed:data-leave:opacity-0 sm:text-sm dark:bg-gray-800 dark:shadow-none dark:-outline-offset-1 dark:outline-white/10"
        >
          {items.map((item) => (
            <ListboxOption
              key={item.userId}
              value={item.userId}
              className="group relative cursor-default py-2 pr-9 pl-3 text-gray-900 select-none data-focus:bg-indigo-600 data-focus:text-white data-focus:outline-hidden dark:text-white dark:data-focus:bg-indigo-500"
            >
              <div className="flex items-center">
                {item.imageUrl ? (
                  <img
                    alt=""
                    src={item.avatar}
                    className="size-5 shrink-0 rounded-full dark:outline dark:-outline-offset-1 dark:outline-white/10"
                  />
                ) : (
                  <span className="inline-block size-5 overflow-hidden rounded-full bg-gray-100 outline -outline-offset-1 outline-black/5 dark:bg-gray-800 dark:outline-white/10">
                    <svg
                      fill="currentColor"
                      viewBox="0 0 24 24"
                      className="size-full text-gray-300 dark:text-gray-600"
                    >
                      <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                    </svg>
                  </span>
                )}
                <span className="ml-3 block truncate font-normal group-data-selected:font-semibold">
                  {item.firstName} {item.lastName}
                </span>
              </div>

              <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-not-data-selected:hidden group-data-focus:text-white dark:text-indigo-400">
                <IconCheck aria-hidden="true" className="size-5" />
              </span>
            </ListboxOption>
          ))}
        </ListboxOptions>
      </div>
    </Listbox>
  );
}
function ButtonLabel({ selected }) {
  return (
    <span className="col-start-1 row-start-1 flex items-center gap-3 pr-6">
      <span className="col-start-1 row-start-1 flex items-center gap-3 pr-6">
        {selected?.imageUrl ? (
          <img
            alt=""
            src={selected.imageUrl}
            className="size-5 shrink-0 rounded-full dark:outline dark:-outline-offset-1 dark:outline-white/10"
          />
        ) : (
          <span className="inline-block size-5 overflow-hidden rounded-full bg-gray-100 outline -outline-offset-1 outline-black/5 dark:bg-gray-800 dark:outline-white/10">
            <svg
              fill="currentColor"
              viewBox="0 0 24 24"
              className="size-full text-gray-300 dark:text-gray-600"
            >
              <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
          </span>
        )}
        {selected ? (
          <span className="block truncate">
            {selected?.firstName} {selected.lastName}
          </span>
        ) : (
          <span className="block truncate text-gray-500">Unassigned</span>
        )}
      </span>
    </span>
  );
}
export default ImageSelectMenu;
